import React from 'react';
import { CheckIcon, HospitalIcon } from 'lucide-react';
import { Button } from './ui/Button';
import { Countdown } from './ui/Countdown';
import { checkoutUrl, price, priceBefore, productShortName, totalBonuses, totalVolumes } from '../data/offer';
const assurances = ['7-day guarantee', 'Secure payment', 'Instant access', 'Teach Surgical Instrumentation with confidence starting today'];
export function FinalCta() {
  return <section className="bg-navy-soft py-16 sm:py-20" aria-labelledby="final-title" data-id="element-86" data-mp="1jbahue7foi1w">
      <div className="mx-auto max-w-3xl px-4 text-center" data-id="element-87" data-mp="1edipjj2vmtx6">
        <p className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-[.16em] text-mineral" data-id="element-88" data-mp="1t3g6bdyh8hcc">
          <HospitalIcon className="h-4 w-4" aria-hidden="true" data-id="element-89" data-mp="1o3lgldqftxsv" /> {productShortName}
        </p>
        <h2 id="final-title" className="mx-auto mt-5 max-w-2xl text-balance text-3xl font-extrabold text-white sm:text-4xl" data-id="element-90" data-mp="222uwsden8rwu">
          Created by surgical instrumentation education specialists, for educators worldwide.
        </h2>

        <Countdown className="mt-8" data-id="element-91" data-mp="n75npw4mel58" />

        <div className="mt-8 flex flex-col gap-5 rounded-xl border-2 border-gold bg-steel p-6 text-left shadow-2xl shadow-black/40 sm:flex-row sm:items-center sm:justify-between" data-id="element-92" data-mp="s4petwmf2sel">
          <p data-id="element-93" data-mp="x5v3njcyhviu">
            <b className="block text-sm uppercase leading-tight text-white" data-id="element-94" data-mp="122ves8onxogt">{productShortName}</b>
            <span className="text-sm text-muted" data-id="element-95" data-mp="164gmlfmcbck5">
              {totalVolumes} volumes + {totalBonuses} bonuses · Instant access
            </span>
          </p>
          <div className="shrink-0 sm:text-right" data-id="element-96" data-mp="1b1yy9drqs5vu">
            <p className="text-sm text-muted" data-id="element-97" data-mp="1fujl1vc8dipv">
              <span className="mr-2 line-through decoration-gold" data-id="element-98" data-mp="1fus1fx7kb65t">{priceBefore}</span>
              <b className="text-base text-mineral" data-id="element-99" data-mp="1ks1ox7be57r0">{price}</b>
            </p>
            <Button href={checkoutUrl} target="_blank" rel="noopener noreferrer" size="sm" className="mt-2" data-id="element-100" data-mp="1pt8vx45pm2wm">
              Get my teacher ready now
            </Button>
          </div>
        </div>

        <ul className="mt-8 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs font-semibold text-muted" data-id="element-101" data-mp="3qtvy8fqed8ha">
          {assurances.map(item => <li key={item} className="inline-flex items-center gap-1.5" data-id="element-102" data-mp="3lthnur1bpmg3">
              <CheckIcon className="h-4 w-4 text-mineral" aria-hidden="true" data-id="element-103" data-mp="3iefuie7zlzi" /> {item}
            </li>)}
        </ul>
      </div>
    </section>;
}